/**
 * CTA al Client Portal en `/congratulations`. Fail-closed: el botón aparece
 * SOLO si `REACT_APP_CLIENT_PORTAL_CTA` vale exactamente 'true'. Sin la
 * variable, o con cualquier otro valor, no hay botón.
 *
 * Es un interruptor propio a propósito: no se deriva de REACT_APP_ENVIRONMENT
 * (compartida con Sentry/Amplitude, con valor de SSM que este repo no controla)
 * ni de NODE_ENV (no distingue Railway de dev-AWS: los dos son bundles
 * compilados). Se prende a mano donde se lo quiere: Railway y `.env.local`.
 */
export function shouldShowPortalCta(flag: string): boolean {
  return (flag || '').trim().toLowerCase() === 'true';
}
